import { RawLink } from '@/shared/ui/RawLink'
import getChannelPrograms from '@/components/tv/helpers/getChannelPrograms'
import useChannelChangeHook from '@/components/tv/hooks/useChannelChangeHook'
import Channel from '@/shared/classes/channels/channel'
import { useEPGStore, useTVStore, useVisibilityStore } from '@/shared/store'
import { Box } from '@mui/material'
import { EpgLinkElement } from '@/shared/ui/EpgLinkElement'
import { CurrentProgram } from '@/shared/ui/CurrentProgram'

interface Props {
    channel: Channel
    onPopperClose?: () => void | undefined
}

export const ChannelView = ({ channel, onPopperClose }: Props) => {
    const { setTvContentVisible } = useVisibilityStore()
    const { selectedChannel } = useTVStore()
    const { epgData } = useEPGStore()

    const programs = getChannelPrograms(epgData, channel)
    const { handleChannelChange } = useChannelChangeHook()
    const { icon, name } = channel

    const isSelectedChannel = selectedChannel
        ? selectedChannel.name === name
        : false

    const handleClick = () => {
        handleChannelChange(channel)
        setTvContentVisible(true)
    }

    const containerStyle = {
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
        width: '100%',
        height: '100vh',
        minHeight: '73px',
        maxHeight: '90px',
        paddingBottom: '13px',
        paddingTop: '14px',
        paddingLeft: { xs: '8px', lg: '12px' },
        backgroundColor: 'custom.midGray',
    }

    const coverStyle = {
        top: isSelectedChannel ? '-2px' : '0',
        width: '100%',
        height: '4px',
        position: 'absolute',
    }

    const imageContainer = {
        mr: '10px',
        width: { xs: '60px', md: '80px' },
        '& > img': {
            width: '100%',
            height: '100%',
            objectFit: 'contain',
        },
    }

    return (
        <>
            <RawLink to="/tv">
                <Box width="80%" height="100%" onClick={handleClick}>
                    <Box sx={coverStyle} />
                    <Box sx={containerStyle}>
                        <Box sx={imageContainer}>
                            <img src={icon} alt="channelLogo" />
                        </Box>
                        <CurrentProgram programs={programs} channel={channel} />
                    </Box>
                </Box>
            </RawLink>
            {channel.id && (
                <Box position="absolute" top="40%" right="0">
                    <EpgLinkElement
                        onPopperClose={onPopperClose}
                        destinationChannelId={channel.id}
                    />
                </Box>
            )}
        </>
    )
}
